import React from "react";
import { useClasses, ITheme, Row, Col } from "@maxeb/admin-ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Block from "./Block";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons/faExclamationTriangle";

export interface IProps {
  text?: string;
}

const style = (theme: ITheme) => ({
  pendingIcon: {
    fontSize: "5rem",
    color: theme.palette.get("danger"),
  },
  pendingBlock: {
    textAlign: "center",
    padding: "46px 0px",
  },
  pendingText: {
    color: theme.palette.get("grey"),
    fontWeight: 100,
  },
});

export default function ErrorBlock(props: IProps) {
  const classes = useClasses(style, props);
  return (
    <Row spacing={12} vertical horizontalAlign="center">
      <Col md="300px">
        <Block>
          <div className={classes.pendingBlock}>
            <FontAwesomeIcon
              className={classes.pendingIcon}
              icon={faExclamationTriangle}
            />
            <p style={{ marginTop: 24 }}>
              {props.text || "Ein unbekannter Fehler ist aufgetreten."}
            </p>
            <p className={classes.pendingText}>
              Bitte versuchen Sie es später erneut.
            </p>
          </div>
        </Block>
      </Col>
    </Row>
  );
}
